module.exports = __webpack_public_path__ + "static/media/date-box-caret.448e4f12.svg";